export default ToCartesian;

function ToCartesian(attrList) {
  const result = [];
  const backTracking = (path, level) => {
    if (path.length === attrList.length) {
      result.push([...path]);
      return;
    }
    attrList[level].forEach((item) => {
      path.push(item);
      backTracking(path, level + 1);
      path.pop();
    });
  };
  backTracking([], 0);
  let result_format = [];
  result.forEach((item) => {
    let cache = "";
    for (let i = 0; i < item.length; i++) {
      if (i != 0) {
        cache = cache + "-" + item[i];
      } else {
        cache = cache + item[i];
      }
    }
    result_format.push(cache);
  });
  return result_format;
}
